import React, { useState } from "react";
import ReactQuill from "react-quill";
import Select from "react-select";
import "react-quill/dist/quill.snow.css";
import axiosInstance from "../../services/api/axios";
import { toast, ToastContainer } from "react-toastify";

function AdhocNotif({ onClose, projectId }) {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [fileAttachment, setFileAttachment] = useState(null);
  const [recipientType, setRecipientType] = useState(null); // react-select value
  const [loading, setLoading] = useState(false);

  const recipientOptions = [
    { value: "Agent", label: "Agent" },
    { value: "User", label: "User" },
  ];

  const handleInputChange = (e, setter) => {
    e.stopPropagation();
    setter(e.target.value);
  };

  const handleFileChange = (e) => {
    e.stopPropagation();
    setFileAttachment(e.target.files[0]);
  };

  const handleRecipientChange = (option) => {
    setRecipientType(option);
  };

  const handleSubmit = async (e) => {
    e.stopPropagation();
    if (!subject || !message || !recipientType) {
      toast.error("All fields are required.");
      return;
    }

    const formData = new FormData();
    formData.append("subject", subject);
    formData.append("message", message);
    formData.append("project_id", projectId);
    if (fileAttachment) {
      formData.append("file_attachment", fileAttachment);
    }
    formData.append("is_agent", recipientType.value === "Agent");

    setLoading(true);

    try {
      await axiosInstance.post("/projects/adhoc-notification", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success("Adhoc Notification sent successfully!");
      onClose();
    } catch (error) {
      console.error("Error sending notification:", error);
      toast.error("Failed to send notification. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-30">
      <ToastContainer />
      <div className="bg-white p-6 rounded-lg shadow-lg w-11/12 md:w-2/3 lg:w-1/2">
        <h5 className="text-gray-800 text-lg font-medium">Send Adhoc Notification</h5>
        <div className="mt-4 space-y-4">
          {/* Subject Input */}
          <div>
            <label htmlFor="subject" className="block text-sm font-medium text-gray-700">
              Subject
            </label>
            <input
              id="subject"
              type="text"
              value={subject}
              onChange={(e) => handleInputChange(e, setSubject)}
              required
              className="mt-1 block w-full rounded-md border border-gray-300 p-2 text-gray-700 focus:border-blue-500 focus:ring-blue-500"
              placeholder="Enter subject"
            />
          </div>

          {/* Message Editor */}
          <ReactQuill
            theme="snow"
            value={message}
            onChange={setMessage}
            placeholder="Write your message here..."
            className="border rounded-md"
          />

          {/* File Attachment */}
          <div>
            <label htmlFor="file" className="block text-sm font-medium text-gray-700">
              File Attachment
            </label>
            <input
              id="file"
              type="file"
              onChange={handleFileChange}
              className="mt-1 block w-full rounded-md border border-gray-300 p-2 text-gray-700"
            />
          </div>

          {/* Recipient Type */}
          <div>
            <label htmlFor="recipientType" className="block text-sm font-medium text-gray-700">
              Recipient Type
            </label>
            <Select
              options={recipientOptions}
              value={recipientType}
              onChange={handleRecipientChange}
              placeholder="Select Recipient Type"
              isSearchable
            />
          </div>
        </div>

        {/* Buttons */}
        <div className="mt-6 flex gap-4">
          <button
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
            className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 focus:outline-none focus:ring focus:ring-gray-300"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-300"
          >
            {loading ? "Sending..." : "Send"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AdhocNotif;
